export default __webpack_public_path__ + "static/media/texture_protection_system.97059a3a.svg";